<template>
  <v-col>
    <v-col>
      <label required class="labels">{{ $t('sales.affiliates_program_affiliates_discount') }}</label>
      <v-radio-group v-model="hasDiscount">
        <v-radio
          :label="$t('sales.affiliates_program_discount_radio')"
          :color="$config.dados.corinputs"
          value="true"
        ></v-radio>
        <v-radio-group
          class="ml-10"
          v-if="hasDiscount === 'true'"
          v-model="discountMethod"
        >
          <v-radio
            :label="$t('sales.affiliates_program_commissioning_fixed_value')"
            :color="$config.dados.corinputs"
            value="money"
            name="radio-buttons"
            @click="valueDiscount = null"
          ></v-radio>
          <v-radio
            :label="$t('sales.affiliates_program_commissioning_percent_value')"
            :color="$config.dados.corinputs"
            value="percent"
            @click="valueDiscount = null"
          ></v-radio>
          <v-text-field
            v-if="discountMethod"
            solo
            dense
            outlined
            :label="getLabelByMethod()"
            :color="$config.dados.corinputs"
            :placeholder="getPlaceholderByMethod()"
            v-model="valueDiscount"
            type="text"
            class="textinput"
            style="max-width: 300px"
            :error-messages="valueError"
            @input="formatInput"
          ></v-text-field>
        </v-radio-group>
        <v-radio
          :label="$t('sales.affiliates_program_discount_no_radio')"
          :color="$config.dados.corinputs"
          value="false"
        ></v-radio>
      </v-radio-group>
    </v-col>
    <v-col
      ><v-btn
        class="btn-color"
        :color="$config.dados.corinputs"
        style="color: white"
        @click="handleSubmitForm()"
      >
        {{ $t('sales.affiliates_program_continue') }}
      </v-btn>
      <v-btn text @click="stepBackProgram()"> {{ $t('sales.affiliates_program_return') }} </v-btn></v-col
    >
  </v-col>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "Discount",
  data() {
    return {
      hasDiscount: null,
      discountMethod: null,
      valueDiscount: null,
      valueError: "",
    };
  },
  computed: {
    ...mapGetters(["dataProgram"]),
  },
  methods: {
    ...mapActions(["nextStepProgram", "stepBackProgram", "showSnackbarError"]),
    ...mapMutations(["setDataProgram"]),
    handleSubmitForm() {
      if (this.hasDiscount === null) {
        this.showSnackbarError(this.$t('sales.affiliates_program_commissioning_select'));
        return;
      }
      if (this.hasDiscount === "true" && this.discountMethod === null) {
        this.showSnackbarError(this.$t('sales.affiliates_program_discount_select'));
        return;
      }
      if (
        this.hasDiscount === "true" &&
        this.discountMethod !== null &&
        !this.valueDiscount
      ) {
        this.valueError = this.$t('sales.affiliate_required');
        this.showSnackbarError(this.$t('sales.affiliate_required'));
        return;
      }
      const discountData = {
        valueDiscount:
          this.discountMethod === "money" ? this.valueDiscount : null,
        percDiscount:
          this.discountMethod === "percent" ? this.valueDiscount : null,
      };
      this.setDataProgram({
        ...this.dataProgram,
        ...discountData,
      });
      this.nextStepProgram();
    },
    getPlaceholderByMethod() {
      if (this.discountMethod === "money") {
        return this.$t('sales.affiliates_program_commissioning_value_example');
      } else if (this.discountMethod === "percent") {
        return this.$t('sales.affiliates_program_commissioning_percent_example');
      }
    },
    getLabelByMethod() {
      if (this.discountMethod === "money") {
        return this.$t('sales.affiliates_program_discount_value');
      } else if (this.discountMethod === "percent") {
        return this.$t('sales.affiliates_program_discount_percent');
      }
    },
    isCommissionMethodMoney() {
      return this.discountMethod === "money";
    },
    formatInput() {
      if (this.discountMethod === "money") {
        this.valueDiscount = this.valueDiscount.replace(/\D/g, "");
        this.valueDiscount = this.valueDiscount.replace(/(\d{2})$/, ",$1");
        this.valueDiscount = this.valueDiscount.replace(
          /(\d)(?=(\d{3})+(?!\d))/g,
          "$1."
        );
        this.valueDiscount = "R$ " + this.valueDiscount;
      } else if (this.discountMethod === "percent") {
        this.valueDiscount = this.valueDiscount.replace(/\D/g, "");
        this.valueDiscount = this.valueDiscount.replace(/(\d{1,2})$/, "$1%");
      }
    },
    formatCurrency(value) {
      const intValue = parseInt(value);
      const decimalValue = (value - intValue).toFixed(2).slice(1);
      const formattedValue = `${intValue.toLocaleString()}${decimalValue}`;
      return `R$${formattedValue.replace(".", ",")}`;
    },
  },
  watch: {
    hasDiscount() {
      if (
        this.hasDiscount === "false" &&
        !this.dataProgram?.valor_desconto &&
        !this.dataProgram?.perc_desconto
      ) {
        this.discountMethod = null;
        this.valueDiscount = null;
      }
    },
    "$store.getters.dataProgram": {
      handler: function (val) {
        if (!this.hasDiscount) {
          this.hasDiscount =
            val?.valor_desconto > 0 || val?.perc_desconto > 0
              ? "true"
              : "false";
          this.discountMethod =
            this.hasDiscount && val?.valor_desconto > 0 ? "money" : "percent";
          this.valueDiscount =
            this.discountMethod === "money" && this.hasDiscount
              ? this.formatCurrency(val.valor_desconto)
              : val.perc_desconto + "%";
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
